import { GetStaticProps, NextPage } from "next";

import { BluetoothLandingPage } from "@components/bluetooth-landing/BluetoothLandingPage";
import * as copy from "@data/ibeacon/enCopy";

const IBeaconAppDevelopmentPage: NextPage = () => (
  <BluetoothLandingPage
    metadata={{
      title: copy.title,
      description: copy.description,
      canonicalPath: "/ibeacon-app-development",
      lang: "en",
      ogLocale: "en_US",
      structuredData: copy.structuredData,
      alternatePaths: {
        en: "/ibeacon-app-development",
        xDefault: "/ibeacon-app-development",
      },
    }}
    navbarCopy={copy.navbarCopy}
    heroCopy={copy.heroCopy}
    targetAudienceCopy={copy.targetAudienceCopy}
    valuePropositionCopy={copy.valuePropositionCopy}
    servicesCopy={copy.servicesCopy}
    processCopy={copy.processCopy}
    aboutUsCopy={copy.aboutUsCopy}
    faqCopy={copy.faqCopy}
    footerCopy={copy.footerCopy}
  />
);

export const getStaticProps: GetStaticProps = async () => ({
  props: {},
});

export default IBeaconAppDevelopmentPage;
